import React, { useState, Fragment } from "react";
import { Grid, Section } from "../../core";
// import { useDispatch } from "react-redux";
// import { updateCurrentPath } from "../../redux/Action/pageRoot";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import styled from "styled-components";
// import AddBuyerForm from "./Form";
import { media, theme } from "../../styles";

import { Typography, Input, Button, Loading } from "../../core";
import { Form, Space } from "antd";
import { MixStyle } from "../../styles";
import { addBuyer } from "../../helper/utils/api/buyer";

const Notify_Utils = require("../../helper/utils/Notification");

const { boxShadow } = theme;

const layout = {
  labelCol: {
    span: 24,
  },

  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label}
  }
`;

const StyledSection = styled(Section)`
  ${media.minitablet`padding: 20px;`};
  padding: 50px;
  margin: 50px 0px;
`;
const AddBuyer = () => {
  const companyId = localStorage.getItem("companyId");
  const [form] = Form.useForm();
  // const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  // dispatch(updateCurrentPath("Buyer"));

  const onFinish = (values) => {
    addBuyerHandler(values);
  };

  const addBuyerHandler = async (values) => {
    if (!companyId) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Please select a company first from the company list."
      );
      return;
    }
    setIsLoading(true);
    try {
      const payload = {
        ...values,
        companyId,
      };
      const response = await addBuyer(payload);
      const message =
        response?.data?.message || "Buyer added successfully";
      Notify_Utils.openNotificationWithIcon("success", message);
      form.resetFields();
    } catch (error) {
      const message =
        error?.response?.data?.message || error?.message || "Failed to add buyer";
      Notify_Utils.openNotificationWithIcon("error", message);
    }
    setIsLoading(false);
  };

  const onFinishFailed = (errorInfo) => {};

  return (
    <Fragment>
      {isLoading ? <Loading /> : null}
      <Grid>
        <Row type="flex" justify="center">
          <Col lg={20} xs={24}>
            <StyledSection radius="15px" shadow={boxShadow.shadowSecond}>
              {/* <AddBuyerForm company_id={company_id} /> */}

              <StyledForm
                autoComplete="off"
                form={form}
                {...layout}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row type="flex" justify="center" gutter={[16, 16]}>
                  <Col md={12} sm={18} xs={24}>
                    <Form.Item
                      label="Buyer Name"
                      name="buyerName"
                      rules={[
                        {
                          required: true,
                          message: "Please input Buyer Name!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={18} xs={24}>
                    <Form.Item
                      label="Company Name"
                      name="companyName"
                      rules={[
                        {
                          required: true,
                          message: "Please input Company Name!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={18} xs={24}>
                    <Form.Item
                      label="Phone Number"
                      name="phoneNumber"
                      rules={[
                        {
                          required: false,
                          message: "Please input Phone Number!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={18} xs={24}>
                    <Form.Item
                      label="NTN"
                      name="NTN"
                      rules={[
                        {
                          required: false,
                          message: "Please input NTN!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col md={12} sm={18} xs={24}>
                    <Form.Item
                      label="STRN"
                      name="STRN"
                      rules={[
                        {
                          required: false,
                          message: "Please input STRN!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={18} xs={24}>
                    <Form.Item
                      label="Address"
                      name="companyAddress"
                      rules={[
                        {
                          required: false,
                          message: "Please input Address!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col md={12}>
                    <Form.List name="GodownAddress">
                      {(fields, { add, remove }) => {
                        return (
                          <div>
                            <Typography
                              align="center"
                              weight="bold"
                              color="#233B67"
                              as="h3"
                            >
                              Godown Address
                            </Typography>
                            {fields.map((field, index) => (
                              <Space
                                key={field.key}
                                style={{
                                  display: "flex",
                                  marginBottom: 8,
                                  justifyContent: "center",
                                }}
                                align="start"
                              >
                                <Form.Item
                                  {...field}
                                  validateTrigger={["onChange", "onBlur"]}
                                  rules={[
                                    {
                                      required: false,
                                      whitespace: true,
                                      message: "Please Input Godown Address",
                                    },
                                  ]}
                                  noStyle
                                >
                                  <Input
                                    placeholder="Godown Address"
                                    style={{ width: "100%" }}
                                  />
                                </Form.Item>
                                {fields.length > 1 ? (
                                  <MinusCircleOutlined
                                    className="dynamic-delete-button"
                                    style={{ margin: "0 8px" }}
                                    onClick={() => {
                                      remove(field.name);
                                    }}
                                  />
                                ) : null}
                              </Space>
                            ))}
                            <Form.Item>
                              <Button
                                width="150px"
                                margin="auto"
                                fontSize="16px"
                                weight="500"
                                height="auto"
                                bg="#ba3d79"
                                onClick={() => {
                                  add();
                                }}
                              >
                                <PlusOutlined /> Add More Godown
                              </Button>
                            </Form.Item>
                          </div>
                        );
                      }}
                    </Form.List>
                  </Col>

                  <Col md={24} sm={18} xs={24}>
                    <Form.List name="departmentInfo">
                      {(fields, { add, remove }) => {
                        return (
                          <div>
                            <Typography
                              align="center"
                              weight="bold"
                              color="#233B67"
                              as="h3"
                            >
                              Department Information
                            </Typography>
                            {fields.map((field, index) => (
                              <Space
                                key={field.key}
                                style={{
                                  display: "flex",
                                  marginBottom: 8,
                                  justifyContent: "space-between",
                                }}
                                align="start"
                              >
                                <Form.Item
                                  {...field}
                                  name={[field.name, "department_name"]}
                                  fieldKey={[field.fieldKey, "department_name"]}
                                  rules={[
                                    {
                                      required: false,
                                      message: "Missing Department Name",
                                    },
                                  ]}
                                >
                                  <Input placeholder="Department Name" />
                                </Form.Item>
                                <Form.Item
                                  {...field}
                                  name={[field.name, "person_name"]}
                                  fieldKey={[field.fieldKey, "person_name"]}
                                  rules={[
                                    {
                                      required: false,
                                      message: "Missing Person Name",
                                    },
                                  ]}
                                >
                                  <Input placeholder="Person Name" />
                                </Form.Item>
                                <Form.Item
                                  {...field}
                                  name={[field.name, "phoneNumber"]}
                                  fieldKey={[field.fieldKey, "phoneNumber"]}
                                  rules={[
                                    {
                                      required: false,
                                      message: "Missing Phone Number",
                                    },
                                  ]}
                                >
                                  <Input placeholder="Phone Number" />
                                </Form.Item>
                                {fields.length > 1 ? (
                                  <MinusCircleOutlined
                                    className="dynamic-delete-button"
                                    style={{ margin: "0 8px" }}
                                    onClick={() => {
                                      remove(field.name);
                                    }}
                                  />
                                ) : null}
                              </Space>
                            ))}

                            <Form.Item>
                              <Button
                                width="150px"
                                margin="auto"
                                fontSize="16px"
                                weight="500"
                                height="auto"
                                bg="#ba3d79"
                                onClick={() => {
                                  add();
                                }}
                              >
                                <PlusOutlined /> Add More Departments
                              </Button>
                            </Form.Item>
                          </div>
                        );
                      }}
                    </Form.List>
                  </Col>
                </Row>

                <Form.Item>
                  <Button
                    width="187px"
                    bg="#404E67"
                    type="primary"
                    htmlType="submit"
                  >
                    <Typography
                      text="Add Buyer"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Form.Item>
              </StyledForm>
            </StyledSection>
          </Col>
        </Row>
      </Grid>
    </Fragment>
  );
};
export default AddBuyer;
